import {
    createFileRoute,
    Outlet,
    useLocation,
    useNavigate,
} from "@tanstack/react-router";
import { Tabs, Tab, Divider } from "@heroui/react";
import useLayout from "@/lib/layout/useLayout";
import { useEffect } from "react";

export const Route = createFileRoute("/dashboard/network")({
    component: NetworkLayout,
});

function NetworkLayout() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { setLayoutState } = useLayout();

    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    const selectedKey = pathname.includes("/organizations")
        ? "organizations"
        : "users";

    return (
        <div className="h-full flex flex-col overflow-hidden">
            <div className="flex flex-row items-center px-2 pt-2">
                <Tabs
                    selectedKey={selectedKey}
                    variant="underlined"
                    color="primary"
                    onSelectionChange={(key) => {
                        navigate({ to: `/dashboard/network/${key}` });
                    }}
                    classNames={{ tabList: "p-0", cursor: "w-full" }}
                >
                    <Tab key="users" title="Users" />
                    <Tab key="organizations" title="Organizations" />
                </Tabs>
            </div>
            <Divider />
            <div className="flex-1 overflow-hidden">
                <Outlet />
            </div>
        </div>
    );
}
